import { render, staticRenderFns } from "./RegistrationMenu.vue?vue&type=template&id=2b789c88&scoped=true"
import script from "./RegistrationMenu.vue?vue&type=script&lang=js"
export * from "./RegistrationMenu.vue?vue&type=script&lang=js"
import style0 from "./RegistrationMenu.vue?vue&type=style&index=0&id=2b789c88&prod&lang=css"
import style1 from "./RegistrationMenu.vue?vue&type=style&index=1&id=2b789c88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b789c88",
  null
  
)

export default component.exports